export { default as CommentsAvatar } from './Avatar.component'
